// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"acf89446","75":"617c3f71","116":"491b244b"}[chunkId] + ".chunk.js";
};